export const GET_PROFILES_REQUEST = 'GET_PROFILES_REQUEST';
export const GET_PROFILES_SUCCESS = 'GET_PROFILES_SUCCESS';
export const GET_PROFILES_FAILURE = 'GET_PROFILES_FAILURE';

export const getProfilesRequest = (filters = {}) => ({
    type: GET_PROFILES_REQUEST,
    payload: {
        filters
    }
});

export const getProfilesSuccess = (profiles) => ({
    type: GET_PROFILES_SUCCESS,
    payload: {
        profiles
    }
});

export const getProfilesFailure = (err) => ({
    type: GET_PROFILES_FAILURE,
    error: err
});